/**
 * wouter navigates with history.pushState/replaceState, which fire no event. Announce them once
 * (`lm:navigate`) so app-wide listeners — the root ErrorBoundary — can react to in-app navigation.
 * Owner audit 2026-10-01: one crashed page (Transport › Content on a 401) left EVERY later screen
 * on the error card because the boundary never reset.
 */
export const NAV_EVENT = "lm:navigate";

export function installNavigationEvents(w: any = typeof window !== "undefined" ? window : undefined,
                                        h: any = typeof history !== "undefined" ? history : undefined): void {
  if (!w || !h || w.__lmNavEvents) return;
  w.__lmNavEvents = true;
  for (const m of ["pushState", "replaceState"] as const) {
    const orig = h[m];
    h[m] = function (this: unknown, ...args: unknown[]) {
      const r = orig.apply(this, args);
      w.dispatchEvent(new Event(NAV_EVENT));
      return r;
    };
  }
}

/** Subscribe to every in-app navigation (push/replace via the patch, back/forward via popstate). */
export function onNavigation(cb: () => void, w: any = typeof window !== "undefined" ? window : undefined): () => void {
  if (!w) return () => {};
  installNavigationEvents(w);
  w.addEventListener(NAV_EVENT, cb);
  w.addEventListener("popstate", cb);
  return () => { w.removeEventListener(NAV_EVENT, cb); w.removeEventListener("popstate", cb); };
}

/** The boundary resets only when the user has moved to a DIFFERENT path than the one that crashed. */
export function shouldResetError(hasError: boolean, errorPath: string | null, currentPath: string): boolean {
  return hasError && currentPath !== errorPath;
}
